module.exports = __webpack_public_path__ + "assets/img/home6.0590e69b.png";